import React, { Component } from "react";
import { firstBy } from "thenby";

import Filter from "../Containers/Filter";
import Model from "../Containers/Model";

import Modal from "../Components/Modal";
import FormSection from "../Components/FormSection";
const url =
  "https://www.skodalaagri.ee/sko/wp-content/themes/skodalaagri2017/rent/";
//"http://skoda_laagri.localhost/wordpress/wp-json/acf/v3/rent/";
export default class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      models: null,
      filters: { order: "start" },
      filteredModels: null,
      unfilteredModels: null,
      modelCount: 0,
      formModal: false,
      modelTypes: {}
    };
  }
  async componentDidMount() {
    const response = await fetch(
      "https://www.skodalaagri.ee/wp-json/acf/v3/rent?per_page=200&orderby=title&order=asc"
     // "http://skoda_laagri.localhost/wordpress/wp-json/acf/v3/rent?per_page=200&orderby=menu_order&order=desc"
    );
    const models = await response.json();
    //console.log(models);

    this.setState(
      {
        models: models,
        unfilteredModels: models,
      },
      () => {
        this.createFilteredModels();
       //this.filterModels();
      }
    );
  }

  closeModal = () => {
    this.setState({ formModal: false, rentInfoModal: false });
  };

  openModalForm = () => {
    this.setState({ formModal: true });
  };

  createFilteredModels() {
    const { models } = this.state;
    let cfm = {};
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    
    today = mm + '/' + dd + '/' + yyyy;
    var date = Date.parse(today);
    let unfilteredModels = {}
  
    Object.keys(models).map((index) => {
     
      if(models[index]?.acf.broneeringu_algus && models[index]?.acf.broneeringu_lopp){
        let start = models[index]?.acf.broneeringu_algus;
        let end = models[index]?.acf.broneeringu_lopp;
          let startArray = start.split(".");
          startArray = Date.parse(startArray[2]+"/"+startArray[1]+"/"+startArray[0]);
          let endArray = end.split(".");
          endArray = Date.parse(endArray[2]+"/"+endArray[1]+"/"+endArray[0]);
        if((startArray > date && endArray > date) || (startArray < date && endArray < date)){
          unfilteredModels = { ...unfilteredModels, [index] : models[index] }

          cfm = { ...cfm, [models[index]?.id]: models[index]?.acf };
        }else{

        }
      }else{
        unfilteredModels = { ...unfilteredModels, [index] : models[index] }
          cfm = { ...cfm, [models[index]?.id]: models[index]?.acf };
     
      }
  
    });
    //console.log(cfm);
    this.createModels( cfm);

    this.setState(
      {
        unfilteredModels: unfilteredModels,
        filteredModels: cfm,
        models: cfm,
      },
      () => {
        this.getModelsCount();

        this.filterModels();
      }
    );
  }

  isNumeric(value) {
    return /^-?\d+$/.test(value);
  }

  filter(model, filters, filter) {
    const modelFilter = model[filter]?.value || model?.[filter];
    if (filter === "order") {
      return true;
    }
    if (this.isNumeric(filters?.[filter]) || filter === "price") {
      //console.log("Price -> ", modelFilter, "is smaller then ", filters?.[filter] , parseInt(modelFilter) < filters?.[filter], model)
      if (parseInt(modelFilter) < filters?.[filter]) {
        return true;
      } else {
        return false;
      }
    } else {
      if (modelFilter.toLowerCase() === filters[filter]?.toLowerCase()) {
        return true;
      } else {
        return false;
      }
    }
  }

  sort(array, type) {
    let newArray = {};
    let sorted = "";
    const filters =
      (this.state.filters.order === "" ||
        this.state.filters.order === undefined) &&
      Object.keys(this.state.filters).length <= 0
        ? true
        : false;
    //console.log("filters---", filters, this.state.filters);

    if (type === "hightolow") {
      sorted = Object.keys(array).sort(
        //by PRICE
        firstBy(function (a, b) {
          return array[b].price - array[a].price;
        })
      );
    } else if (type === "start") {
      sorted = Object.keys(array).sort(
        //by PRICE
        firstBy(function (a, b) {
          return array[a].price - array[b].price;
        })
      );
    } else if (type === "noreserved") {
     // array = this.checkIfTimeIsPast(array);
     var datenow = Date.now();
      sorted = Object.keys(array).sort(
        //by PRICE
      
        firstBy(function (a, b) {
          //console.log(Date.parse(array[a].broneeringu_lopp),datenow, Date.parse(array[a].broneeringu_lopp) < datenow ? "yes": "no");
          return  ( !isNaN(Date.parse(array[a].broneeringu_lopp)) && Date.parse(array[a].broneeringu_lopp) > datenow )  ? 1 : -1;
        })
      );
    } else {
      sorted = Object.keys(array).sort(
        //by PRICE

        //firstBy(function (a, b) { return  array[b].price - array[a].price; }, -1)
        firstBy(function (a, b) { return  array[a].fuel - array[b].fuel; })
        .thenBy(function (a, b) { return  array[b].price - array[a].price; }, -1)
      );
    }

    sorted.map((id) => {
      // console.log(id);
      let name = "id_" + id;
      newArray = { ...newArray, [name]: array[id] };
    });

    if (filters) {
      newArray = {};
      Object.keys(this.state.unfilteredModels).map((index) => {
        let name = "id_" + this.state.unfilteredModels[index].id;
        newArray = {
          ...newArray,
          [name]: this.state.unfilteredModels[index]?.acf,
        };
      });
    }

    //console.log("sorted ->", sorted, newArray);
    return newArray;
  }

  checkIfTimeIsPast(car, current) {
    //console.log("yesyese->", car);
    var curDate = Date.now();
    Object.keys(car).map((c) => {
      if (
        car[c].broneeringu_lopp !== "" &&
        !isNaN(Date.parse(car[c].broneeringu_lopp))
      ) {
       // console.log(c, current)
        if (c === current) {
          return 1;
        } else {
          return 0;
        }
      }
    });
  }

  filterModels() {
    const { filters, filteredModels, models } = this.state;

    let filteredModelsAfter = {};

    Object.keys(models).map((m) => {
      let model = models[m];
      // console.log("-->", m, models[m]);
      let allFiltersMatch = true;
      Object.keys(filters).map((filter) => {
        if (!this.filter(model, filters, filter)) {
          allFiltersMatch = false;
          
          //  console.log("YES ---> ", filter, filters[filter], filteredModels);
        }
      });
      if (allFiltersMatch) {
        filteredModelsAfter = {
          ...filteredModelsAfter,
          [m]: models[m],
        };
      }
    });

    filteredModelsAfter = this.sort(filteredModelsAfter, filters["order"]);
     //console.log("after sorting", filteredModelsAfter);
    this.setState(
      {
        filteredModels: filteredModelsAfter,
      },
      () => this.getModelsCount()
    );
  }

  getModelsCount() {
    const { filteredModels } = this.state;
    //console.log("filtered Models->", filteredModels[0]);
    this.setState({ modelCount: 0 });
    setTimeout(() => {
      this.setState({ modelCount: Object?.keys(filteredModels)?.length });
    }, 10);
  }

  setFilters(filters) {
    //console.log("filters? ", filters);
    this.setState({ filters }, () => this.filterModels());
  }

  uniq_fast(a) {
    var seen = {};
    var out = [];
    var len = a.length;
    var j = 0;
    for(var i = 0; i < len; i++) {
         var item = a[i];
         if(seen[item] !== 1) {
               seen[item] = 1;
               out[j++] = item;
         }
    }
    return out;
}


  createModels (models) {
    //console.log("asdasdasd",models)
    let array = [];
    let modelsGrouping = {};
    let val1 = "";
    Object.keys(models).map((val) => {
      val1 = models[val].model.split(" ")
      val1 = val1[0];
      array = [...array,val1];
    //  modelsGrouping[val1] = { ...modelsGrouping[val1][val] };

    })
    //console.log("modelsGrouping", modelsGrouping)
   let uniqueArray = this.uniq_fast(array)
    this.setState({
      modelTypes:uniqueArray,
      modelsGrouping: modelsGrouping
    })
  }
  render() {
    const { models, filteredModels, unfilteredModels, modelTypes } = this.state;
    if (filteredModels) {
      return (
        <div className="Models--wrapper">
          {/*<Header /> */}
          <div className="header">
            <img
              className="rent--logo"
              alt="Škoda laagri autorent"
              src={`${url}images/rendilogo.svg`}
            />
            <Filter modelTypes={modelTypes} setFilters={(filter) => this.setFilters(filter)} models={unfilteredModels}/>
          </div>
          <div className="Models--header">
            <h2>
              Tutvu autodega,{" "}
              <span className="text--color__primary">
                <span
                  className={`foundCars ${
                    this.state.modelCount ? "animate" : ""
                  } `}
                >
                  {this.state.modelCount}
                </span>

                <span>{this.state.modelCount === 1 ? "auto" : "autot"}</span>
              </span>
            </h2>
          </div>
          <div className="Models">
            {Object.keys(filteredModels).map((model, i) => {
              //console.log("model -> ", filteredModels[model]);
              return <Model model={filteredModels[model]} id={model} key={i} />;
            })}
          </div>
          {this.state.formModal ? (
            <Modal close={(e) => this.closeModal()}>
              <FormSection />
            </Modal>
          ) : (
            ""
          )}
          <div className="Models--footer">
            <button
              className="button button--special"
              onClick={() => this.openModalForm()}
            >
              KÜSI PAKKUMIST
            </button>
          </div>
        </div>

        /*
      
      Filtering
      cars
      
      */
      );
    }
  }
}
